// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_EDe","cls2":"ReportList-cls2_mBI ReportList-cls1_EDe"};